import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'toString'

}) export class ToString implements PipeTransform {

transform(input: number): string{ //string type
   return input + '';
} }